import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RestaurantState } from './restaurant.types';
import { Restaurant } from '../../models/restaurant';

const initialState: RestaurantState = {
  restaurantId: null,
  restaurant: null,
  loading: false,
  error: null,
};

const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    setRestaurantId: (state, action: PayloadAction<string|null>) => {
      console.log(`SET RESTAURANT ID [${action.payload}]`);
      state.restaurantId = action.payload;
      state.loading = true;
    },
    restaurantUpdated: (state, action: PayloadAction<Restaurant>) => {
      state.restaurant = action.payload;
      state.loading = false;
      state.error = null;
    },
    restaurantListenerError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetRestaurant: (state) => {
      state.restaurant = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setRestaurantId,
  restaurantUpdated,
  restaurantListenerError,
  resetRestaurant,
} = restaurantSlice.actions;

export default restaurantSlice.reducer;
